import { Controller } from "@hotwired/stimulus"

// 🚨 修正: ファイルがロードされたことを確認するための最上位ログを追加
console.log("--- Stimulus: tab_loader_controller.js file loaded ---");

// タブ切り替え時に、対応するTurbo Frameにデータをロードするコントローラー
export default class extends Controller {
  static targets = ["tabList", "contentA"] // contentAターゲットを追加

  static values = { url: String } // data-tab-loader-url-valueを取得

  connect() {
    // 1. Aタブの初期ロードを実行
    this.loadInitialTab()
    
    // 2. 他のタブの切り替えイベントリスナーを設定
    // 💡 修正: メソッド名を load に統一したため、イベントリスナーも load に変更
    this.tabListTarget.addEventListener('shown.bs.tab', this.load)
    console.log("TabLoaderController connected. Initial A-tab load attempted.")
  }

  disconnect() {
    // 💡 修正: メソッド名を load に統一したため、イベントリスナーも load に変更
    this.tabListTarget.removeEventListener('shown.bs.tab', this.load)
    console.log("TabLoaderController disconnected.")
  }

  // Aタブのコンテンツをロードする
  loadInitialTab() {
    const frame = this.contentATarget // data-tab-loader-target="contentA" を取得
    
    // URLはコントローラー全体から取得（data-tab-loader-url-value）
    // StimulusのURL Valueは、Railsのパスヘルパーの結果（/report/1/ticket_analysis/available_status）
    // 💡 修正: 初期ロード用のURLはそのままurlValueを使用
    const initialUrl = this.urlValue

    if (frame && (!frame.src || frame.src.length === 0)) {
        console.log(`[ACTION] Initial A-tab content loading from: ${initialUrl}`)
        frame.src = initialUrl
    } else {
        console.log("[SKIPPED] Initial A-tab load skipped (frame.src is already set or frame not found).")
    }
  }

  // 💡 修正: loadTabContent を load にリネームし、主なロードロジックをここに統一
  // このメソッドが shown.bs.tab イベントでも click->tab-loader#load アクションでも呼ばれる
  load = (event) => {
    // shown.bs.tab イベントから呼ばれた場合は event.target がタブボタン
    // click アクションから呼ばれた場合は event.currentTarget がタブボタン (event.target は aタグの子要素になる可能性も)
    const targetButton = event.target || event.currentTarget
    
    const tabId = targetButton.dataset.tab // 'a', 'b', 'c', 'd', 'e'
    const turboFrameId = `analysis_content_${tabId}`
    const turboFrame = document.getElementById(turboFrameId)
    
    // 💡 data-load-url 属性から直接ロード先の完全なURLを取得する
    const loadUrl = targetButton.dataset.loadUrl

    // デバッグログ
    console.log("--- Tab Load Event Triggered ---")
    console.log(`Target Event Type: ${event.type}`) // どのイベントで呼ばれたか確認用
    console.log(`Clicked Tab ID: ${tabId}`)
    console.log(`Searching for Turbo Frame ID: ${turboFrameId}`)
    console.log(`Load URL: ${loadUrl}`)

    if (turboFrame && loadUrl) {
      // 以前ロードされていない場合のみsrcを設定
      // **重要** Bタブ、Cタブ以降はsrcがない場合にロードする
      if (!turboFrame.src || turboFrame.src.length === 0) {
         console.log(`[ACTION] Loading content for tab ${tabId}.`)
         turboFrame.src = loadUrl
      } else {
         console.log(`[SKIPPED] Content for tab ${tabId} already loaded (src is present).`)
      }
    } else {
      console.error(`[ERROR] Could not load content. Turbo Frame ID: ${turboFrameId} not found or loadUrl is missing.`)
    }
    console.log("---------------------------------")
  }
}
